import React, { useEffect, useState } from "react"

import styles from "./EmbedVimeo.module.scss"

function vimeo_parser(url) {
  var regExp =
    /^.*(vimeo\.com\/)((channels\/[A-z]+\/)|(groups\/[A-z]+\/videos\/))?([0-9]+)/
  var match = url.match(regExp)
  return match && match[5] ? match[5] : false
}

const EmbedVimeo = ({ url, ratio }) => {
  const videoID = vimeo_parser(url)

  const [paddingBottom, setPaddingBottom] = useState("56.25%")

  useEffect(() => {
    if (ratio) {
      // If the component has received an explicitly stated aspect ratio
      let aspectRatioArray = ratio.split(":")
      if (aspectRatioArray.length === 2) {
        setPaddingBottom(
          Math.round((aspectRatioArray[1] / aspectRatioArray[0]) * 100 * 10) /
            10 +
            "%"
        )
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return videoID ? (
    <div className={styles.element}>
      <div style={{ paddingBottom: paddingBottom }}>
        <iframe
          title={`vimeo-${videoID}`}
          id={`vimeo-${videoID}`}
          src={`https://player.vimeo.com/video/${videoID}`}
          width="640"
          height="360"
          frameBorder="0"
          allow="autoplay; fullscreen; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>
    </div>
  ) : null
}

export default EmbedVimeo
